export const mapEmpresas = (selectedEmpresa) => {
  const empresaMapping = {
    TODAS: ["2", "3"],
    ALTAMIRA: ["2"],
    "LA SIEMBRA": ["3"],
  };
  return empresaMapping[selectedEmpresa.toUpperCase()] || [];
};

export const mapTipos = (tipoProductoArray) => {
  return tipoProductoArray.map((tipo) => tipo.id);
};

export const mapDateFilters = (desde, hasta) => {
  const dateObjectDesde = new Date(desde);
  const dateObjectHasta = new Date(hasta);
  const desdeFiltro = dateObjectDesde.toISOString().split("T")[0];
  const hastaFiltro = dateObjectHasta.toISOString().split("T")[0];

  return { desdeFiltro, hastaFiltro };
};

export const validarFiltrosProductos = ({ empresa, tipoProducto, desde, hasta }) => {
  const basicChecks =
    empresa !== null &&
    empresa !== undefined &&
    empresa !== "" &&
    tipoProducto !== null &&
    tipoProducto !== undefined &&
    tipoProducto !== "" &&
    desde !== null &&
    desde !== undefined &&
    hasta !== null &&
    hasta !== undefined &&
    hasta !== "";

  const dateChecks = new Date(hasta) >= new Date(desde);

  const currentDate = new Date();
  const currentDateChecks =
    new Date(desde) >= currentDate && new Date(hasta) >= currentDate;

  const isDateValid = dateChecks && currentDateChecks;

  if (!basicChecks) {
    return { valid: false, message: "Debe ingresar todos los parámetros de búsqueda" };
  }
  if (!isDateValid) {
    return {
      valid: false,
      message:
        "Las fechas deben ser mayores a la de hoy y la fecha de término debe ser mayor o igual a la de inicio",
    };
  }

  return { valid: true, message: null };
};
